/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import SliceProvider from "../../../redux/ducks/Wizard/SliceProvider";

const WithWizardProvider = (props) => (Component) => (moreProps) => {
  return (
    <SliceProvider slice={props?.slice}>
      <Component {...props} >
        {props?.children}
      </Component>
    </SliceProvider>
  )
};

export default WithWizardProvider